import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "@/components/UI/Link/Link";
import Button from "@/components/UI/Button/Button";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section03Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const ToolsAndAppsSection = ({ job, page, section, ...props }: Section03Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer className="flex-row" section={section}>
        <div className="flex flex-1 flex-col gap-10">
          <SectionHeader className="text-left" section={section} />
          <div className="flex flex-1 flex-col gap-10">
            {section?.List && (
              <ul className="flex flex-col gap-2">
                {section?.List?.map((item: any) => {
                  return (
                    <li className="flex items-center gap-2" key={item?.id}>
                      <FontAwesomeIcon className="text-vpGreen-500" icon={faCheck} />
                      <span>{item?.Value}</span>
                    </li>
                  );
                })}
              </ul>
            )}
            {section?.Button && (
              <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
                <Button>{section?.Button?.Value}</Button>
              </Link>
            )}
          </div>
        </div>
        {section?.Image?.data?.attributes && (
          <div className="hidden lg:block lg:flex-1">
            <Image
              alt={section?.Image?.data?.attributes?.alternativeText}
              src={section?.Image?.data?.attributes?.url}
              width={section?.Image?.data?.attributes?.width ?? "100"}
              height={section?.Image?.data?.attributes?.height ?? "100"}
              priority
            />
          </div>
        )}
      </SectionContainer>
    </Section>
  );
};

export default ToolsAndAppsSection;
